import React, { useEffect, useState } from 'react';
import { api } from '@/App';
import BetaFeedbackButton from '@/components/BetaFeedbackButton';
import { Sparkle, X } from '@phosphor-icons/react';

const THRESHOLD = 3;

/**
 * Banner shown on Dashboard once a user has engaged with 3+ planning tools.
 * Asks for beta feedback via the external Google Form. Dismissible (per user).
 */
const BetaFeedbackBanner = () => {
  const [show, setShow] = useState(false);
  const [toolsUsed, setToolsUsed] = useState([]);

  useEffect(() => {
    api.get('/tool-usage/progress')
      .then((res) => {
        const { count, banner_dismissed, tools_used } = res.data;
        setToolsUsed(tools_used || []);
        if (count >= THRESHOLD && !banner_dismissed) {
          setShow(true);
        }
      })
      .catch(() => {});
  }, []);

  const dismiss = async () => {
    setShow(false);
    try { await api.post('/tool-usage/dismiss-banner'); } catch (e) {}
  };

  if (!show) return null;

  return (
    <div
      className="bg-[#0A1128] text-white rounded-md p-5 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 shadow-md"
      data-testid="beta-feedback-banner"
    >
      <div className="flex items-start gap-3 w-full sm:flex-1 sm:min-w-0">
        <Sparkle size={22} weight="duotone" className="text-[#C5A059] flex-shrink-0 mt-0.5" />
        <div className="min-w-0 flex-1">
          <p className="text-xs uppercase tracking-[0.12em] text-[#C5A059] font-semibold">Help shape PLANIVANCE AI</p>
          <p className="text-base font-medium mt-1">
            You've used {toolsUsed.length} planning tools — your feedback is invaluable.
          </p>
          <p className="text-xs text-[#A0AABF] mt-1">
            Take 3 minutes to share what's working, what's confusing, and what you wish existed.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 w-full sm:w-auto sm:flex-shrink-0 justify-end">
        <BetaFeedbackButton variant="primary" label="Share Beta Feedback" testid="banner-feedback-button" />
        <button
          onClick={dismiss}
          data-testid="banner-dismiss-button"
          className="text-white/60 hover:text-white"
          aria-label="Dismiss banner"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default BetaFeedbackBanner;
